import { render, staticRenderFns } from "./MemberDialog.vue?vue&type=template&id=36e476e0&scoped=true"
import script from "./MemberDialog.vue?vue&type=script&lang=js"
export * from "./MemberDialog.vue?vue&type=script&lang=js"
import style0 from "./MemberDialog.vue?vue&type=style&index=0&id=36e476e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e476e0",
  null
  
)

export default component.exports